<template>
  <div class="search-bar flex align-center">
    <div class="left" v-if="showBack" @click="onBack">
      <van-icon slot="left-icon" size="24" class="back-icon" name="cap-back" />
    </div>

    <slot name="label" />

    <form class="search-input" action="/">
      <van-search
        v-model.trim="value"
        clearable
        :show-action="showAction"
        :placeholder="placeholderText"
        @search="onSearch"
        @clear="onClear"
        @input="onInput"
        background="#fff"
        maxlength="50"
        @focus="onFocus"
        shape="circle"
        @click="emitClick"
        class="custom-search"
      >
        <template #action v-if="shopIcon">
          <slot name="action">
            <van-icon
              class="cell-title-icon"
              size="24"
              :name="require('../../assets/imgs/ic_my_medical.png')"
            ></van-icon>
          </slot>
        </template>
        <template #action v-else>
          <slot name="action">
            <div @click="onAction" class="text-btn">搜索</div>
          </slot>
        </template>

        <icon-font slot="left-icon" class="search-icon" icon-name="sousuo" />

        <!-- <van-icon slot="left-icon" class="search-icon" name="cap-search" /> -->
      </van-search>
    </form>
  </div>
</template>

<script>
import iconFont from '@/components/iconFont.vue';

export default {
  components: { iconFont },
  props: {
    searchValue: {
      type: String,
      default: ''
    },
    placeholderText: {
      type: String,
      default: '请输入搜索关键词'
    },
    showAction: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: true
    },
    focus: {
      type: Boolean,
      default: true
    },
    shopIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: ''
    };
  },
  watch: {
    value(val) {
      this.$emit('update:searchValue', val);
    },
    searchValue: {
      handler: function (newVal) {
        this.value = newVal;
      },
      immediate: true
    },
    focus(newVal) {
      if (newVal) {
        document.querySelector('input').focus();
      }
    }
  },

  mounted() {
    if (this.focus) {
      document.querySelector('input').focus();
    }
  },
  methods: {
    onAction() {
      this.$emit('onAction', this.value);
    },

    onSearch() {
      this.$emit('onSearch', this.value);
    },

    onClear() {
      this.$emit('onClear');
    },

    onFocus() {
      this.$emit('onFocus');
    },

    onInput(val) {
      this.$emit('onInput', val);
    },

    onBack() {
      this.$emit('onBack');
      // this.$router.go(-1);
    },
    emitClick() {
      this.$emit('emitClick');
    }
  }
};
</script>

<style lang="less" scoped>
.text-btn {
  width: 28px;
  font-size: 16px;
  white-space: nowrap;
  color: #1e8dff;
}
.search-bar {
  .search-input {
    flex: 1;
  }
  .left {
    margin-left: 16px;
    margin-right: -10px;
  }

  .back-icon {
    width: 24px;
    height: 24px;
    color: #333333;
  }
}
.custom-search {
  ::v-deep .van-search__action {
    margin-left: 8px;
  }
}

.search-icon {
  width: 15px;
  height: 15px;
  color: #8c8c8c;
  margin-bottom: 4px;
}
</style>
